import React from "react";
import { useEffect, useState, useRef } from "react"
import { mixOther } from "api/mixOther";

type Home = {
  meta_title: string;
  meta_description: string;
  meta_keywords: string;
  quick_icon_1: string;
  quick_name_1: string;
  quick_link_1: string;
  quick_icon_2: string;
  quick_name_2: string;
  quick_link_2: string;
};

const GiuseartNav: React.FC = () => {

    const [home, setHome] = useState<Home | null>(null)
    
      useEffect(() => {
            const loadOther = async () => {
                const res = await mixOther("sshome","vi")
                    if (!res?.status || !res.data?.json) {
                    return;
                }
    
                try {
                    const parsed = JSON.parse(res.data.json);
                    setHome((prev) => ({ ...prev, ...parsed }));
                } catch (error) {
                    console.error("Failed to parse setting JSON:", error);
                }
            };
    
            loadOther();
        }, [])

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="giuseart-nav">
      <ul>
        <li>
          <a
            href={home?.quick_link_1}
            target="_blank"
            rel="noreferrer"
          >
            <div className="img-box">
              <img
                src={home?.quick_icon_1}
                alt="..."
                loading="lazy"
              />
            </div>
            <span className="text">
              {home?.quick_name_1}
            </span>
          </a>
        </li>

        <li>
          <a
            href={ `tel:${home?.quick_link_2}`}
            target="_blank"
            rel="noreferrer"
          >
            <div className="img-box">
              <img
                src={home?.quick_icon_2}
                alt="..."
                loading="lazy"
              />
            </div>
            <span className="text">
              {home?.quick_name_2}
            </span>
          </a>
        </li>

        <li className="btn_phone_txt">
          <div className="back-top" onClick={toTop}>
            <svg
              height="24"
              width="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 Z M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M8.70710678,16.7071068 L7.29289322,15.2928932 L12,10.5857864 L16.7071068,15.2928932 L15.2928932,16.7071068 L12,13.4142136 L8.70710678,16.7071068 Z M8.70710678,12.7071068 L7.29289322,11.2928932 L12,6.58578644 L16.7071068,11.2928932 L15.2928932,12.7071068 L12,9.41421356 L8.70710678,12.7071068 Z"
              />
            </svg>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default GiuseartNav;